(() => {
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  // The main image carries a srcset (800w/1100w/1400w of the same Shopify CDN image) so phones do not download the
  // 1400w file. A swap must replace src and srcset together, because srcset wins over src in the browser.
  const MAIN_WIDTHS = [800, 1100, 1400];
  function setMainImage(image, url) {
    if (/[?&]width=\d+/.test(url)) {
      image.srcset = MAIN_WIDTHS.map(w => `${url.replace(/([?&])width=\d+/, `$1width=${w}`)} ${w}w`).join(', ');
    } else {
      image.removeAttribute('srcset');
    }
    image.src = url;
  }
  async function loadProduct(handle) {
    if (!handle) return null;
    const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
    if (!response.ok) throw new Error('Product information is unavailable.');
    return response.json();
  }
  function init(section) {
    const $ = selector => section.querySelector(selector);
    const state = { products: {}, loading: true };
    const message = text => { $('[data-message]').textContent = text || ''; };
    const selected = name => section.querySelector(`input[name="krdh-${name}-${section.dataset.sectionId}"]:checked`)?.value;
    const size = () => Number(selected('size'));
    const flavor = () => selected('flavor');
    const isMix = () => $('[data-mix-toggle]').checked;
    const quantity = () => Math.max(1, Number($('[data-quantity]').value) || 1);
    const variant = () => state.products[flavor()]?.variants.find(v => v.title.toLowerCase().includes(`${size()} bars`));
    // Recurpay attaches every pack's plan group to the whole product, so Shopify offers each pack every plan; its
    // product-page widget picks one plan per pack. The map mirrors that choice so the homepage charges the same price.
    const planMap = Object.fromEntries((section.dataset.planMap || '').split(/[\s,]+/).filter(Boolean).map(entry => {
      const [variantId, sellingPlanId, recurpayPlanId] = entry.split(':').map(Number);
      return [variantId, { sellingPlanId, recurpayPlanId }];
    }));
    const allocation = v => {
      const mapped = planMap[v?.id]?.sellingPlanId;
      const preferred = Number(section.dataset.sellingPlan || 0);
      return (mapped && v?.selling_plan_allocations?.find(a => a.selling_plan_id === mapped))
        || v?.selling_plan_allocations?.find(a => preferred && a.selling_plan_id === preferred) || v?.selling_plan_allocations?.[0];
    };
    const planName = (product, sellingPlanId) => product?.selling_plan_groups?.flatMap(g => g.selling_plans).find(p => p.id === sellingPlanId)?.name;
    // Mixed box: each flavor is counted in 10-bar steps (one 10-bar mix product each); the counts must fill the pack.
    const MIX_STEP = 10;
    const mix = { pb: 20, aloha: 10 };
    const resetMix = () => { const n = size(); mix.aloha = n >= 2 * MIX_STEP ? MIX_STEP : 0; mix.pb = n - mix.aloha; };
    const mixCounts = () => ({ pb: mix.pb, aloha: mix.aloha });
    const mixTotal = () => mix.pb + mix.aloha;
    const mixValid = () => {
      const counts = mixCounts();
      return Object.values(counts).every(n => Number.isInteger(n) && n >= 0 && n % MIX_STEP === 0) && counts.pb + counts.aloha === size();
    };
    // First subscription box price per pack (automatic discounts at checkout), from the section setting "20:75, 30:109".
    const firstBox = Object.fromEntries(($('[data-first-box]')?.dataset.firstBox || '').split(/[\s,]+/).filter(Boolean).map(entry => {
      const [pack, dollars] = entry.split(':');
      return [Number(pack), Math.round(Number(dollars) * 100)];
    }).filter(([pack, cents]) => pack > 0 && cents > 0));
    const mixPrice = () => {
      const counts = mixCounts();
      return (counts.pb / 10) * (state.products.mixPb?.variants[0]?.price || 0) + (counts.aloha / 10) * (state.products.mixAloha?.variants[0]?.price || 0);
    };
    function setFlavorGallery() {
      const main = $('.krdh-offer__main-image');
      const current = flavor();
      const source = current === 'aloha' ? main.dataset.alohaMain : main.dataset.pbMain;
      if (source) setMainImage(main, source);
      main.alt = state.products[current]?.title || (current === 'aloha' ? 'Aloha Caramel' : 'PB Toffee Crunch');
      section.querySelectorAll('[data-gallery-flavor]').forEach(button => { button.hidden = button.dataset.galleryFlavor !== current; });
    }
    function render() {
      const mixed = isMix();
      const v = variant();
      const a = allocation(v);
      const subscribed = selected('plan') === 'subscription';
      const bars = size();
      $('[data-size-summary]').textContent = `${bars} Bars`;
      $('.krdh-offer__mix-controls').hidden = !mixed;
      $('[data-mix-note]').hidden = !mixed;
      $('[data-mix-total]').hidden = !mixed;
      $('[data-mix-total]').textContent = `${mixTotal()} / ${bars} bars`;
      $('[data-mix-total]').classList.toggle('is-full', mixTotal() === bars);
      ['pb', 'aloha'].forEach(key => {
        $(`[data-mix-count="${key}"]`).textContent = mix[key];
        $(`[data-mix-step="${key}"][data-dir="-1"]`).disabled = mix[key] <= 0;
        $(`[data-mix-step="${key}"][data-dir="1"]`).disabled = mixTotal() + MIX_STEP > bars;
      });
      // A single-flavor subscription's first box is charged the pack's first-box price (automatic discount at
      // checkout, applied once per cart: two 30-bar boxes total $109 + $125); later boxes are the plan price.
      const first = !mixed && a && firstBox[bars] && firstBox[bars] < a.price ? firstBox[bars] : 0;
      const subNow = first || a?.price || 0;
      const price = mixed ? mixPrice() : (subscribed && a ? a.price : v?.price || 0);
      const total = !mixed && subscribed && a ? subNow + a.price * (quantity() - 1) : price * quantity();
      const oneTime = mixed ? mixPrice() : v?.price || 0;
      const perBarCount = mixed ? mixTotal() : bars;
      const perBar = cents => (perBarCount ? `${money(cents / perBarCount)} / bar` : '');
      $('[data-onetime-price]').textContent = oneTime ? money(oneTime) : '—';
      $('[data-onetime-per-bar]').textContent = oneTime ? perBar(oneTime) : '';
      $('[data-subscribe-price]').textContent = a && !mixed ? money(subNow) : '—';
      $('[data-subscribe-per-bar]').textContent = a && !mixed ? perBar(subNow) : '';
      const compare = !mixed && v && a && v.price > subNow ? v.price : 0;
      $('[data-subscribe-compare]').textContent = compare ? money(compare) : '';
      const save = $('[data-subscribe-save]');
      save.hidden = !compare;
      save.textContent = compare ? `Save ${money(compare - subNow).replace(/\.00$/, '')}` : '';
      const firstLine = $('[data-subscribe-first]');
      if (mixed || !a) {
        firstLine.textContent = '';
      } else if (first) {
        firstLine.innerHTML = '';
        const strong = document.createElement('strong');
        strong.textContent = `First box ${money(first)}`;
        firstLine.append(strong, `, then ${money(a.price)} per box`);
      } else {
        firstLine.textContent = `${money(a.price)} per box`;
      }
      firstLine.hidden = !firstLine.textContent;
      // Free subscription gift: only a single-flavor Subscribe & Save box of an eligible pack size qualifies.
      const gift = $('[data-sub-gift]');
      if (gift) gift.hidden = mixed || !subscribed || !(gift.dataset.subGiftSizes || '').split(/[\s,]+/).map(Number).includes(bars);
      $('[data-button-price]').textContent = total ? `— ${money(total)}` : '';
      const error = state.loading ? 'Loading current prices…' : mixed && subscribed ? 'Mixed boxes are available as one-time purchases only.' : mixed && !mixValid() ? `Add ${size() - mixTotal()} more bars to fill your ${size()}-bar box.` : mixed && (!state.products.mixPb || !state.products.mixAloha) ? 'Mixed-box products are unavailable.' : !mixed && !v ? 'This size is unavailable for this flavor.' : subscribed && !a ? 'A subscription is unavailable for this selection.' : '';
      $('[data-add-to-cart]').disabled = Boolean(error);
      message(error);
      const sticky = document.querySelector(`[data-krdh-sticky="${section.dataset.sectionId}"]`);
      if (sticky) sticky.querySelector('[data-sticky-price]').textContent = total ? money(total) : '';
    }
    section.addEventListener('change', event => {
      if (event.target.matches('input')) {
        if (event.target.matches('[data-mix-toggle]') && event.target.checked) section.querySelector(`input[name="krdh-plan-${section.dataset.sectionId}"][value="one-time"]`).checked = true;
        if (event.target.name === `krdh-flavor-${section.dataset.sectionId}`) setFlavorGallery();
        if (event.target.name === `krdh-size-${section.dataset.sectionId}`) resetMix();
        render();
      }
    });
    section.addEventListener('click', event => {
      const step = event.target.closest('[data-mix-step]');
      if (!step || step.disabled) return;
      const key = step.dataset.mixStep;
      const next = mix[key] + Number(step.dataset.dir) * MIX_STEP;
      if (next < 0 || mixTotal() - mix[key] + next > size()) return;
      mix[key] = next;
      render();
    });
    section.addEventListener('input', event => { if (event.target.matches('input')) render(); });
    section.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
      const image = $('.krdh-offer__main-image'); setMainImage(image, button.dataset.image); image.alt = button.dataset.alt;
    }));
    $('[data-nutrition-open]')?.addEventListener('click', () => $('[data-nutrition-dialog]').showModal());
    $('[data-nutrition-close]')?.addEventListener('click', () => $('[data-nutrition-dialog]').close());
    $('[data-add-to-cart]').addEventListener('click', async () => {
      const button = $('[data-add-to-cart]');
      button.disabled = true; message('Adding to cart…');
      try {
        const items = [];
        if (isMix()) {
          const counts = mixCounts();
          if (counts.pb) items.push({ id: state.products.mixPb.variants[0].id, quantity: counts.pb / 10 * quantity() });
          if (counts.aloha) items.push({ id: state.products.mixAloha.variants[0].id, quantity: counts.aloha / 10 * quantity() });
        } else {
          const item = { id: variant().id, quantity: quantity() };
          if (selected('plan') === 'subscription') {
            const sellingPlanId = allocation(variant()).selling_plan_id;
            item.selling_plan = sellingPlanId;
            // Same line properties the Recurpay product-page widget sends.
            const recurpayPlanId = planMap[variant().id]?.sellingPlanId === sellingPlanId ? planMap[variant().id].recurpayPlanId : null;
            const name = planName(state.products[flavor()], sellingPlanId);
            if (recurpayPlanId && name) item.properties = { _Plan: name, _PlanId: String(recurpayPlanId) };
          }
          items.push(item);
        }
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json().catch(() => ({ message: 'Could not add this selection. Please try again.' }));
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add this selection.');
        window.location.assign(window.routes?.cart_url || '/cart');
      } catch (error) { render(); message(error.message); }
    });
    const sticky = $(`[data-krdh-sticky="${section.dataset.sectionId}"]`);
    sticky?.querySelector('[data-sticky-add]')?.addEventListener('click', () => $('[data-add-to-cart]').click());
    if (sticky) {
      // The sticky bar sits at the bottom of the viewport from the start, so a lazy <img> would still be fetched on
      // load; its picture is only requested the first time the bar is actually shown.
      const stickyImage = sticky.querySelector('img[data-sticky-src]');
      const updateSticky = () => {
        const show = window.scrollY > section.offsetTop + 500;
        sticky.classList.toggle('is-visible', show);
        if (show && stickyImage && stickyImage.dataset.stickySrc) { stickyImage.src = stickyImage.dataset.stickySrc; stickyImage.removeAttribute('data-sticky-src'); }
      };
      window.addEventListener('scroll', updateSticky, { passive: true }); updateSticky();
    }
    Promise.allSettled([loadProduct(section.dataset.pb), loadProduct(section.dataset.aloha), loadProduct(section.dataset.mixPb), loadProduct(section.dataset.mixAloha)]).then(results => {
      ['pb','aloha','mixPb','mixAloha'].forEach((key,i) => { if (results[i].status === 'fulfilled') state.products[key] = results[i].value; });
      state.loading = false; render();
    });
    resetMix();
    render();
  }
  const boot = root => root.querySelectorAll('.krdh-offer').forEach(section => { if (!section.dataset.initialized) { section.dataset.initialized = 'true'; init(section); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
